import React from 'react';
import { IFriend } from '../../types/friend';
import ChatEditor from '../chat-editor/chat-editor.component';
import { IChat, SendMessagePayload } from '../../types/chat';
import ChatContent from '../chat-content/chat-content.component';
import { useNavigate } from 'react-router-dom';

interface ChatDetailProps {
  user: IFriend;
  newMessage: IChat | null;
  handleSendMessage: (payload: SendMessagePayload) => void;
}

const ChatDetail = ({
  user,
  newMessage,
  handleSendMessage,
}: ChatDetailProps) => {
  const navigator = useNavigate();
  return (
    <div className="flex">
      <div className="flex-1">
        <div className="flex flex-col justify-between">
          <div className="flex bg-[#F0F2F5] items-center justify-between gap-2 w- px-6 py-3.5  z-10 border-b dark:border-slate-700 uk-animation-slide-top-medium ">
            <div className="flex items-center sm:gap-4 gap-2">
              <div
                onClick={() => navigator(`/user/${user.userName}`)}
                className="relative cursor-pointer max-md:hidden"
              >
                <img
                  alt="user"
                  src={
                    user.avatar ||
                    '/default-avatar.svg'
                  }
                  className="w-12 h-12 rounded-full shadow"
                />
              </div>
              <div className="cursor-pointer">
                <div
                  onClick={() => navigator(`/user/${user.userName}`)}
                  className="text-[24px] leading-[29px] text-[#111827] font-bold"
                >
                  {user.fullName}
                </div>
                {/* <div className="text-xs text-green-500 font-semibold">
                  Online
                </div> */}
              </div>
            </div>
          </div>

          <ChatContent user={user} newMessage={newMessage} />

          <ChatEditor user={user} handleSendMessage={handleSendMessage} />
        </div>
      </div>
    </div>
  );
};

export default ChatDetail;
